import { Box, Container } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router'
import AddUpdateDialog from 'src/components/common/addUpdateDialog'
import FilterSection from 'src/components/common/filterSection'
import PlayerComponent from 'src/components/helperComponents/PlayerComponent'
import AddEditVideo from 'src/components/Videos/AddEditVideo'
import useQueryTable from 'src/hooks/useQueryTable'
import useVideoCategoryDropdowns from 'src/hooks/useVideoCategoryDropdown'
import { DeleteVideoById } from 'src/redux/actions'
import { LocalTable } from 'src/ui/Table'
import { GetLessonVideoTableColumns } from 'src/util/columns'

const EntertainmentVideoList = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const [customFilterQuery, setCustomFilterQuery] = useState({
    sort: '-createdAt',
  })

  const [recordToEdit, setRecordToEdit] = useState()
  const [mediaUrl, setMediaUrl] = useState()
  const [searchText, setSearchText] = useState(null)
  const { categories } = useVideoCategoryDropdowns()

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  })

  const columns = useMemo(() => GetLessonVideoTableColumns(setMediaUrl), [])

  const { data, isLoading, isFetching, refetch } = useQueryTable({
    name: 'videos',
    searchText: searchText,
    pageIndex: pageIndex,
    pageSize: pageSize,
    additionalFilters: customFilterQuery,
  })

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const videoSlug = params.get('slug')
    if (videoSlug) {
      setCustomFilterQuery(prev => ({
        ...prev,
        slug: videoSlug,
      }))
    }
  }, [location.search])


  const onDeleteRow = async (recordToDelete) => {
    if (recordToDelete) {
      await dispatch(DeleteVideoById(recordToDelete));
      await refetch();
    }
  }

  return (
    <>
      <Helmet>
        <title>Entertainment Video | Langistan</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          minHeight: '100%',
          py: 3,
        }}
      >
        <Container maxWidth={false}>

          {/* addButton filters & search section  */}
          <FilterSection
            type="4L Video Library"
            setSearchText={setSearchText}
            setRecordToEdit={setRecordToEdit}
          />

          {/* Videos Data list */}
          <Box sx={{ pt: 3 }}>
            <LocalTable
              columns={columns}
              onEditClick={setRecordToEdit}
              onDeleteClick={onDeleteRow}
              // additionalFilters={customFilterQuery}
              data={data}
              name="Video"
              isLoading={isLoading}
              isFetching={isFetching}
              setPagination={setPagination}
            />
          </Box>

          {mediaUrl && (
            <PlayerComponent
              url={mediaUrl}
              onDialogCancel={() => setMediaUrl()}
            />
          )}

          {/* Add & Update 4L Video */}
          <AddUpdateDialog
            open={!!recordToEdit}
            title={`${Object.keys(recordToEdit ?? {}).length ? "Update" : "Create"} 4L Videos`}
            onClose={() => {
              setRecordToEdit();
            }
            }
            maxWidth="md"
          >
            <Box mt={2}>
              <AddEditVideo
                selectedRow={recordToEdit}
                toggleDrawer={() => setRecordToEdit()}
                refetch={refetch}
                categories={categories}
              />
            </Box>
          </AddUpdateDialog>

        </Container>
      </Box>
    </>
  )
}

export default EntertainmentVideoList
